import type { ReactNode } from "react";

import { useTranslate } from "@similarweb/i18n-provider";
import { colorsPalettes } from "@similarweb/styles";
import { Flex, Stack, Text } from "@similarweb/ui-components/foundations";

type AccountSignalTypeSectionEmptyStateProps = {
    action?: ReactNode;
};

export const AccountSignalTypeSectionEmptyState = ({ action }: AccountSignalTypeSectionEmptyStateProps) => {
    const { translate } = useTranslate();

    return (
        <Stack
            gap="12px"
            width="100%"
            alignItems="flex-start"
        >
            <Flex
                width="100%"
                justifyContent="center"
                alignItems="center"
                paddingY="32px"
                borderRadius="8px"
                border={`1px dashed ${colorsPalettes.carbon[100]}`}
                data-automation="account-signals-section-empty-state"
            >
                <Text
                    fontVariant="body2"
                    color={colorsPalettes.carbon[300]}
                >
                    {translate("si.account-signals.management.section.empty-state.text")}
                </Text>
            </Flex>
            {action}
        </Stack>
    );
};
